import { AbsoluteFill, useCurrentFrame, staticFile } from "remotion";
import { Img } from "remotion";
import { Video } from "remotion";
import { interpolate } from "remotion";

// Scene 1 Component - Opening atmosphere
const Scene1 = () => {
  const frame = useCurrentFrame();
  
  // Calculate fade in for the text
  const fadeIn = interpolate(frame, [0, 30], [0, 1], { extrapolateLeft: "clamp", extrapolateRight: "clamp" });
  
  return (
    <AbsoluteFill style={{ 
      justifyContent: "center", 
      alignItems: "center",
      flexDirection: "column",
      backgroundColor: "#0a0a0a"
    }}>
      <div
        style={{
          fontSize: 48,
          fontWeight: "bold",
          color: "#fff",
          fontFamily: "Georgia, serif",
          textTransform: "uppercase",
          letterSpacing: "2px",
          textAlign: "center",
          opacity: fadeIn,
          transform: `translateY(${interpolate(frame, [0, 15], [20, 0], { extrapolateLeft: "clamp", extrapolateRight: "clamp" })}px)`,
        }}
      >
        From Design to Detail
      </div>
      <div
        style={{
          fontSize: 24,
          color: "#f5f5f5",
          fontFamily: "Georgia, serif",
          textAlign: "center",
          opacity: fadeIn,
          transform: `translateY(${interpolate(frame, [5, 20], [30, 0], { extrapolateLeft: "clamp", extrapolateRight: "clamp" })}px)`,
          marginTop: "10px"
        }}
      >
        A custom wedding mirror sign
      </div>
    </AbsoluteFill>
  );
};

// Scene 2 Component - Process begins
const Scene2 = () => {
  const frame = useCurrentFrame();
  
  // Calculate fade in for the overlay text
  const fadeIn = interpolate(frame, [75, 105], [0, 1], { extrapolateLeft: "clamp", extrapolateRight: "clamp" });
  
  return (
    <AbsoluteFill style={{ backgroundColor: "#000" }}>
      <Video
        src={staticFile("media/process-video-1.mp4")}
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
        }}
      />
      <AbsoluteFill 
        style={{ 
          backgroundColor: "rgba(0,0,0,0.5)",
          justifyContent: "center",
          alignItems: "center"
        }}
      >
        <div
          style={{
            fontSize: 32,
            fontWeight: "bold",
            color: "#fff",
            fontFamily: "Georgia, serif",
            textAlign: "center",
            lineHeight: 1.4,
            opacity: fadeIn,
            width: "80%"
          }}
        >
          Every detail begins with precision
        </div>
        <div
          style={{
            fontSize: 18,
            color: "#d4af37", // champagne gold
            fontFamily: "Georgia, serif",
            textAlign: "center",
            opacity: fadeIn,
            marginTop: "10px"
          }}
        >
          Step 1 • Crafting
        </div>
      </AbsoluteFill>
    </AbsoluteFill>
  );
};

// Scene 3 Component - Weeded design detail
const Scene3 = () => {
  const frame = useCurrentFrame();
  
  // Calculate zoom and fade for the image
  const scale = interpolate(frame, [195, 255], [1, 1.15], { extrapolateLeft: "clamp", extrapolateRight: "clamp" });
  const fadeIn = interpolate(frame, [230, 260], [0, 1], { extrapolateLeft: "clamp", extrapolateRight: "clamp" });
  
  return (
    <AbsoluteFill style={{ backgroundColor: "#000" }}>
      <Img 
        src={staticFile("media/weeded-photo.jpg")}
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
          transform: `scale(${scale})`,
        }}
      />
      <AbsoluteFill 
        style={{ 
          justifyContent: "center",
          alignItems: "center"
        }}
      >
        <div
          style={{
            fontSize: 32,
            fontWeight: "bold",
            color: "#fff",
            fontFamily: "Georgia, serif", 
            textAlign: "center",
            opacity: fadeIn,
            textShadow: "0 0 5px rgba(0,0,0,0.7)"
          }}
        >
          Careful craftsmanship
        </div>
        <div
          style={{
            fontSize: 18,
            color: "#d4af37", // champagne gold
            fontFamily: "Georgia, serif",
            textAlign: "center",
            opacity: fadeIn,
            marginTop: "10px",
            textShadow: "0 0 5px rgba(0,0,0,0.7)"
          }}
        >
          Step 2 • Detail Work  
        </div>
      </AbsoluteFill>
    </AbsoluteFill>
  );
};

// Scene 4 Component - Making / transition scene
const Scene4 = () => {
  const frame = useCurrentFrame();
  
  // Calculate fade in for the overlay text
  const fadeIn = interpolate(frame, [315, 345], [0, 1], { extrapolateLeft: "clamp", extrapolateRight: "clamp" });
  
  return (
    <AbsoluteFill style={{ backgroundColor: "#000" }}>
      <Video
        src={staticFile("media/process-video-2.mp4")}
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
        }}
      />
      <AbsoluteFill 
        style={{ 
          backgroundColor: "rgba(0,0,0,0.3)",
          justifyContent: "center",
          alignItems: "center"
        }}
      >
        <div
          style={{
            fontSize: 32,
            fontWeight: "bold",
            color: "#fff",
            fontFamily: "Georgia, serif",
            textAlign: "center",
            lineHeight: 1.4,
            opacity: fadeIn,
            width: "80%"
          }}
        >
          Careful craftsmanship
        </div>
        <div
          style={{
            fontSize: 18,
            color: "#d4af37", // champagne gold
            fontFamily: "Georgia, serif",
            textAlign: "center",
            opacity: fadeIn,
            marginTop: "10px"
          }}
        >
          Step 2 • Detail Work
        </div>
      </AbsoluteFill>
    </AbsoluteFill>
  );
};

// Scene 5 Component - Final product reveal
const Scene5 = () => {
  const frame = useCurrentFrame();
  
  // Calculate zoom and title fades for the mirror
  const scale = interpolate(frame, [405, 465], [1, 1.15], { extrapolateLeft: "clamp", extrapolateRight: "clamp" });
  
  // Staggered text appearance
  const title1Opacity = interpolate(frame, [420, 450], [0, 1], { extrapolateLeft: "clamp", extrapolateRight: "clamp" });
  const title2Opacity = interpolate(frame, [465, 495], [0, 1], { extrapolateLeft: "clamp", extrapolateRight: "clamp" });
  const title3Opacity = interpolate(frame, [510, 540], [0, 1], { extrapolateLeft: "clamp", extrapolateRight: "clamp" });
  
  return (
    <AbsoluteFill style={{ backgroundColor: "#000" }}>
      <Img 
        src={staticFile("media/final-gold-mirror.jpg")} 
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
          transform: `scale(${scale})`,
        }}
      />
      <AbsoluteFill 
        style={{ 
          justifyContent: "center",
          alignItems: "center"
        }}
      >
        <div
          style={{
            fontSize: 42,
            fontWeight: "bold",
            color: "#fff",
            fontFamily: "Georgia, serif", 
            textAlign: "center",
            opacity: title1Opacity,
            textShadow: "0 0 5px rgba(0,0,0,0.7)"
          }}
        >
          Love is Sweet
        </div>
        <div
          style={{
            fontSize: 42,
            fontWeight: "bold", 
            color: "#d4af37", // champagne gold
            fontFamily: "Georgia, serif",
            textAlign: "center",
            opacity: title2Opacity,
            marginTop: "10px",
            textShadow: "0 0 5px rgba(0,0,0,0.7)"
          }}
        >
          Laura & Brian
        </div>
        <div
          style={{
            fontSize: 22,
            color: "#fff",
            fontFamily: "Georgia, serif",
            textAlign: "center",
            opacity: title3Opacity,
            marginTop: "15px"
          }}
        >
          October 17, 2026
        </div>
      </AbsoluteFill>
    </AbsoluteFill>
  );
};

// Scene 6 Component - Luxury brand outro
const Scene6 = () => {
  const frame = useCurrentFrame();
  
  // Calculate fade in for the text
  const fadeIn = interpolate(frame, [555, 570], [0, 1], { extrapolateLeft: "clamp", extrapolateRight: "clamp" });
  
  return (
    <AbsoluteFill style={{ 
      backgroundColor: "#000",
      justifyContent: "center",
      alignItems: "center"
    }}>
      <div
        style={{
          fontSize: 36,
          fontWeight: "bold",
          color: "#fff",
          fontFamily: "Georgia, serif",
          textAlign: "center",
          opacity: fadeIn,
        }}
      >
        Akshar Creations PEI
      </div>
      <div
        style={{
          fontSize: 20,
          color: "#f5f5f5",
          fontFamily: "Georgia, serif", 
          textAlign: "center",
          marginTop: "10px",
          opacity: fadeIn,
        }}
      >
        Custom Wedding Details
      </div>
      <div
        style={{
          fontSize: 16,
          color: "#d4af37", // champagne gold
          fontFamily: "Georgia, serif",
          textAlign: "center",
          marginTop: "15px",
          opacity: fadeIn,
        }}
      >
        Mirrors • Cake Toppers • Personalized Creations
      </div>
    </AbsoluteFill>
  );
};

export const LauraBrianMirrorCinematic = () => {
  const frame = useCurrentFrame();
  
  // Scene durations (frames)
  const scene1Duration = 75; // 2.5 seconds
  const scene2Duration = 120; // 4 seconds
  const scene3Duration = 120; // 4 seconds  
  const scene4Duration = 90;  // 3 seconds
  const scene5Duration = 150; // 5 seconds
  const scene6Duration = 45;  // 1.5 seconds
  
  // Determine which scene to render based on frame
  if (frame >= 0 && frame < scene1Duration) {
    return <Scene1 />;
  } else if (frame >= scene1Duration && frame < scene1Duration + scene2Duration) {
    return <Scene2 />;
  } else if (frame >= scene1Duration + scene2Duration && frame < scene1Duration + scene2Duration + scene3Duration) {
    return <Scene3 />;
  } else if (frame >= scene1Duration + scene2Duration + scene3Duration && frame < scene1Duration + scene2Duration + scene3Duration + scene4Duration) {
    return <Scene4 />;
  } else if (frame >= scene1Duration + scene2Duration + scene3Duration + scene4Duration && frame < scene1Duration + scene2Duration + scene3Duration + scene4Duration + scene5Duration) {
    return <Scene5 />;
  } else if (frame >= scene1Duration + scene2Duration + scene3Duration + scene4Duration + scene5Duration && frame < scene1Duration + scene2Duration + scene3Duration + scene4Duration + scene5Duration + scene6Duration) {
    return <Scene6 />;
  }
  
  // Fallback - should never reach here
  return <AbsoluteFill style={{ backgroundColor: "#000" }} />;
};

export default LauraBrianMirrorCinematic;